import React from 'react';
import moment from 'moment';

export const FULL_DATE = 'MM/DD/YYYY';
export const SHORT_DATE = 'MM/YYYY';

export const defaultShortcuts = [
  {
    label: <strong>Today</strong>,
    hotkey: 'O',
    date: moment(),
  },
  {
    label: (
      <span>
        End of previous
        <strong> month</strong>
      </span>
    ),
    hotkey: 'M',
    date: moment().subtract(1, 'months').endOf('month'),
  },
  {
    label: (
      <span>
        End of previous
        <strong> quarter</strong>
      </span>
    ),
    hotkey: 'Q',
    date: moment().subtract(1, 'quarters').endOf('quarter'),
  },
  {
    label: (
      <span>
        End of previous
        <strong> year</strong>
      </span>
    ),
    hotkey: 'Y',
    date: moment().subtract(1, 'years').endOf('year'),
  },
];

export const shortcutsWithoutHotkeys = defaultShortcuts.map(shortcut => ({
  label: shortcut.label,
  date: shortcut.date,
}));
